import {Component} from '@angular/core';

@Component({
  selector: 'app-title-spinner',
  templateUrl: './title-spinner.component.html',
  styleUrls: ['./title-spinner.component.scss']
})
export class TitleSpinnerComponent {}
